/**
 * Created by Mark on 23/11/2016.
 */

import BaseStore from './base-store.js';
import AuthenticationConstants from '../constants/authnetication.js';

class AuthenticationStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.apiToken = sessionStorage.getItem('token');
        this.warning    = false;
        this.permission = 500;
        this.userData   = {}
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case AuthenticationConstants.LOGIN_USER:
                this.apiToken = action.apiToken;
                this.warning = false;
                this.emitChange();
            break;
            case AuthenticationConstants.GET_USER_DATA:
                this.userData = action.response
                this.emit(AuthenticationConstants.GET_USER_DATA);
                break;
            case AuthenticationConstants.LOGOUT_USER:
                this.apiToken = null;
                this.warning = false;
                this.emitChange();
                break;
            case "LOGOUT_WARNING":
                this.warning = true;
                this.emit("WARNING_USER");
                break;
            case AuthenticationConstants.GRANT_PERMISSION:
                this.permission = action.permission;
                this.emit("GOT_PERMISSION")
                break;
            default:
                break;
        }

    }

    hasCreatePermissions(){
        return Number(this.permission) != 444;
    }

    isAuthenticated(){
       return this.apiToken != null;
    }
}



export default new AuthenticationStore();


// WEBPACK FOOTER //
// ./src/store/authentication-store.js